module.exports = __webpack_public_path__ + "static/media/book-dead.c227c341.svg";